module.exports = __webpack_public_path__ + "img/insta-stream-logo.png";